// all images imported from images directory
import product_01_image_01 from "../images/product_01.jpg";
import product_01_image_02 from "../images/product_01.1.jpg";
import product_01_image_03 from "../images/product_01.3.jpg";

import product_02_image_01 from "../images/product_2.1.jpg";
import product_02_image_02 from "../images/product_2.2.jpg";
import product_02_image_03 from "../images/product_2.3.jpg";

import product_03_image_01 from "../images/product_3.1.jpg";
import product_03_image_02 from "../images/product_3.2.jpg";
import product_03_image_03 from "../images/product_3.3.jpg";

import product_04_image_01 from "../images/product_4.1.jpg";
import product_04_image_02 from "../images/product_4.2.jpg";
import product_04_image_03 from "../images/product_4.3.png";

import product_05_image_01 from "../images/product_04.jpg";
import product_05_image_02 from "../images/product_08.jpg";
import product_05_image_03 from "../images/product_09.jpg";

import product_06_image_01 from "../images/bread(1).png";
import product_06_image_02 from "../images/bread(2).png";
import product_06_image_03 from "../images/bread(3).png";

const products = [{
    id: "01",
    title: "Tomato",
    price: 24.0,
    image01: product_01_image_01,
    image02: product_01_image_02,
    image03: product_01_image_03,
    category: "Vegetable",

    desc: "Discover the essence of vibrant tomatoes – plump, juicy, and rich in flavor. Elevate salads, sauces, and dishes with nature's ruby.",
  },

  {
    id: "02",
    title: "EggPlant",
    price: 115.0,
    image01: product_02_image_01,
    image02: product_02_image_02,
    image03: product_02_image_03,
    category: "Vegetable",

    desc: "Indulge in the versatile allure of eggplants. Their firm texture and mild taste transform dishes into culinary delights. Elevate your cooking.",
  },

  {
    id: "03",
    title: "Cherry",
    price: 110.0,
    image01: product_03_image_01,
    image02: product_03_image_02,
    image03: product_03_image_03,
    category: "Fruits",

    desc: "Indulge in the delight of cherries – nature's sweet gems. Bursting with freshness, these vibrant treats add joy to every moment.",
  },

  {
    id: "04",
    title: "Almond",
    price: 110.0,
    image01: product_04_image_01,
    image02: product_04_image_02,
    image03: product_04_image_03,
    category: "Fruits",

    desc: "Indulge in the delicate crunch of almonds. Packed with nutrients, our almonds offer a wholesome snack or versatile ingredient for culinary creations.",
  },

  {
    id: "05",
    title: "Nuts",
    price: 24.0,
    image01: product_05_image_01,
    image02: product_05_image_02,
    image03: product_05_image_03,
    category: "Fruits",

    desc: "Indulge in the crunch of wholesome nuts. Packed with nutrients and delectable taste, they're nature's perfect snack for vitality and pleasure.",
  },
  {
    id: "06",
    title: "Tomato",
    price: 24.0,
    image01: product_01_image_01,
    image02: product_01_image_02,
    image03: product_01_image_03,
    category: "Vegetable",

    desc: "Discover the essence of vibrant tomatoes – plump, juicy, and rich in flavor. Elevate salads, sauces, and dishes with nature's ruby.",
  },

  {
    id: "07",
    title: "Cucumber",
    price: 115.0,
    image01: product_02_image_02,
    image02: product_02_image_01,
    image03: product_02_image_03,
    category: "Vegetable",

    desc: "Experience the crisp refreshment of our cucumbers. Versatile and hydrating, they add a delightful crunch to salads and snacks.",
  },

  {
    id: "08",
    title: "Pumpkin",
    price: 110.0,
    image01: product_03_image_02,
    image02: product_03_image_01,
    image03: product_03_image_03,
    category: "Vegetable",

    desc: "Embrace the earthy charm of pumpkins. Versatile and nutritious, our pumpkins bring warmth to soups, stews, and baked delights, enriching every bite.",
  },

  {
    id: "09",
    title: "Cabbage",
    price: 110.0,
    image01: product_04_image_02,
    image02: product_04_image_01,
    image03: product_04_image_03,
    category: "Vegetable",

    desc: "Experience the crisp and versatile cabbage – a culinary delight. From crunchy slaws to hearty stir-fries, embrace its wholesome goodness.",
  },

  {
    id: "10",
    title: "Squash",
    price: 24.0,
    image01: product_05_image_02,
    image02: product_05_image_01,
    image03: product_05_image_03,
    category: "Vegetable",

    desc: "Indulge in the versatile delight of squash. Its tender texture and subtly sweet taste add depth to dishes, embodying culinary creativity.",
  },

  {
    id: "11",
    title: "Crunchy Bread ",
    price: 35.0,
    image01: product_06_image_01,
    image02: product_06_image_02,
    image03: product_06_image_03,
    category: "Bread",

    desc: "Savor the delight of our crunchy bread, a symphony of golden crust and soft interior. Perfect for satisfying cravings and creating memorable meals.",
  },

  {
    id: "12",
    title: "Delicious Bread ",
    price: 35.0,
    image01: product_06_image_02,
    image02: product_06_image_01,
    image03: product_06_image_03,
    category: "Bread",

    desc: "Savor the irresistible delight of our artisanal bread. Crispy golden crust, tender interior – a symphony of taste and texture in every bite.",
  },

  {
    id: "13",
    title: "Loaf Bread ",
    price: 35.0,
    image01: product_06_image_03,
    image02: product_06_image_02,
    image03: product_06_image_03,
    category: "Bread",

    desc: "Savor the simplicity of our freshly baked loaf bread. A golden-brown crust embraces soft, airy slices, perfect for wholesome sandwiches and comforting moments.",
  },
];

export default products;